var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"navbar navbar-expand-md navbar-dark d-flex justify-content-between"},[_c('div'),_c('div',{staticClass:"d-flex navbar-icon align-items-center"},[(!_vm.hideBasket)?_c('Basket'):_vm._e(),_c('NavbarDropdown',{staticClass:"ml-auto ml-2 navbar-icon"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }